(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Warp"] = factory();
	else
		root["Warp"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getSegmentSchema = getSegmentSchema;
exports.isDrawingSegment = isDrawingSegment;
exports.createLineSegment = createLineSegment;
exports.joinSegments = joinSegments;
var segmentSchemas = {
	m: ['x', 'y'],
	z: [],
	l: ['x', 'y'],
	h: ['x'],
	v: ['y'],
	c: ['x1', 'y1', 'x2', 'y2', 'x', 'y'],
	s: ['x2', 'y2', 'x', 'y'],
	q: ['x1', 'y1', 'x', 'y'],
	t: ['x', 'y'],
	a: ['rx', 'ry', 'xRotation', 'largeArc', 'sweep', 'x', 'y']
};

var pointGroups = exports.pointGroups = [['x1', 'y1'], ['x2', 'y2'], ['x', 'y']];

var drawingCmdExpr = /[lhvcsqta]/;

function getSegmentSchema(type) {
	return segmentSchemas[type.toLowerCase()];
}

function isDrawingSegment(segment) {
	return drawingCmdExpr.test(segment.type);
}

function createLineSegment(points) {
	var segment = { relative: false };

	switch (points.length) {
		case 2:
			{
				segment.type = 'l';
			}break;
		case 3:
			{
				segment.type = 'q';
			}break;
		case 4:
			{
				segment.type = 'c';
			}break;
		default:
			return false;
	}

	for (var i = 1; i < points.length; i++) {
		var g = (i < points.length - 1 ? i : pointGroups.length) - 1;

		var _pointGroups$g = _slicedToArray(pointGroups[g], 2),
		    x = _pointGroups$g[0],
		    y = _pointGroups$g[1];

		segment[x] = points[i][0];
		segment[y] = points[i][1];

		if (points[i].length > 2) {
			segment.extended = segment.extended || {};
			segment.extended[g] = points[i].slice(2);
		}
	}

	return segment;
}

function joinSegments(segmentA, segmentB) {
	if (segmentA.type === segmentB.type && segmentA.relative === segmentB.relative) {
		var setExtended = function setExtended(pointsA, pointsB, type) {
			if (pointsA && pointsB) {
				var points = [];
				var pointCount = Math.min(pointsA.length, pointsB.length);

				for (var i = 0; i < pointCount; i++) {
					points.push((pointsA[i] + pointsB[i]) / 2);
				}

				segment.extended[type] = points;
			}
		};

		var type = segmentB.type,
		    relative = segmentB.relative,
		    x = segmentB.x,
		    y = segmentB.y;

		var bothExtended = !!segmentA.extended && !!segmentB.extended;
		var extended = {};
		var segment = { type: type, relative: relative, x: x, y: y, extended: extended };

		switch (type) {
			case 'l':
				break;
			case 'q':
				{
					segment.x1 = (segmentA.x1 + segmentB.x1) / 2;
					segment.y1 = (segmentA.y1 + segmentB.y1) / 2;

					if (bothExtended) {
						setExtended(segmentA.extended[0], segmentB.extended[0], 0);
					}
				}
				break;
			case 'c':
				{
					segment.x1 = (segmentA.x1 + segmentA.x2) / 2;
					segment.y1 = (segmentA.y1 + segmentA.y2) / 2;
					segment.x2 = (segmentB.x1 + segmentB.x2) / 2;
					segment.y2 = (segmentB.y1 + segmentB.y2) / 2;

					if (bothExtended) {
						setExtended(segmentA.extended[0], segmentA.extended[1], 0);
						setExtended(segmentB.extended[0], segmentB.extended[1], 1);
					}
				}
				break;
			default:
				{
					return false;
				}
		}

		if (segmentB.extended && segmentB.extended[2]) {
			extended[2] = segmentB.extended[2];
		}

		return segment;
	}

	return false;
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = transform;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function transform(path, transformer) {
	var newPath = [];

	for (var i = 0; i < path.length; i++) {
		var segment = JSON.parse(JSON.stringify(path[i]));
		var result = transformer(segment, i, path, newPath);

		if (Array.isArray(result)) {
			newPath.push.apply(newPath, _toConsumableArray(result));
		} else if (result) {
			newPath.push(result);
		}
	}

	return newPath;
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = parser;

var _utils = __webpack_require__(0);

var segmentExpr = /([mzlhvcsqta])([^mzlhvcsqta]*)/ig;
var numberExpr = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;

function parser(pathString) {
	var pathData = [];

	var segmentMatch = void 0;
	segmentExpr.lastIndex = 0;

	while (segmentMatch = segmentExpr.exec(pathString)) {
		var type = segmentMatch[1].toLowerCase();
		var numbers = (segmentMatch[2].match(numberExpr) || []).map(parseFloat);
		var relative = type === segmentMatch[1];

		var schema = (0, _utils.getSegmentSchema)(type);

		if (numbers.length < schema.length) {
			throw new Error('Malformed path data: type "' + type + '" has ' + numbers.length + ' arguments, expected ' + scheme.length);
		}

		if (schema.length > 0) {
			if (numbers.length % schema.length !== 0) {
				throw new Error('Malformed path data: type "' + type + '" has ' + numbers.length + ' arguments, ' + numbers.length % schema.length + ' too many');
			}

			for (var i = 0; i < numbers.length / schema.length; i++) {
				var segmentData = { type: type, relative: relative };

				for (var j = 0; j < schema.length; j++) {
					segmentData[schema[j]] = numbers[i * schema.length + j];
				}

				pathData.push(segmentData);
			}
		} else {
			pathData.push({ type: type, relative: relative });
		}
	}

	return pathData;
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = encoder;

var _utils = __webpack_require__(0);

function encoder(pathData) {
	var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

	var prevType = false;
	var magnitude = Math.pow(10, precision);

	return pathData.map(function (segment) {
		var output = [];
		var outputType = segment.relative ? segment.type : segment.type.toUpperCase();
		var first = prevType !== outputType;

		var schema = (0, _utils.getSegmentSchema)(segment.type);

		if (first) {
			output.push(outputType);
			prevType = outputType;
		}

		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = schema[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var property = _step.value;

				var value = segment[property];
				var outputValue = void 0;

				switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
					case 'boolean':
						{
							outputValue = value | 0;
						}break;
					case 'number':
						{
							outputValue = (value * magnitude | 0) / magnitude;
						}break;
					default:
						throw new Error('Invalid path data');
				}

				if (!first) {
					output.push(' ');
				}

				output.push(outputValue);
				first = false;
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		return output.join('');
	}).join('');
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createElement = createElement;
exports.getProperty = getProperty;
exports.setProperty = setProperty;
function createElement(tag) {
	var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	var element = document.createElementNS('http://www.w3.org/2000/svg', tag);

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = Object.keys(attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var name = _step.value;

			setProperty(element, name, attributes[name]);
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return element;
}

function getProperty(element, property) {
	if (element[property] instanceof SVGAnimatedLength) {
		return element[property].baseVal.value;
	}

	return element.getAttribute(property);
}

function setProperty(element, property, value) {
	element.setAttribute(property, value);
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.split = split;
exports.until = until;
exports.euclideanDistance = euclideanDistance;
function split(p) {
	var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;

	var seg0 = [];
	var seg1 = [];
	var orders = [p];

	while (orders.length < p.length) {
		var q = orders[orders.length - 1];
		var r = [];

		for (var i = 1; i < q.length; i++) {
			var q0 = q[i - 1];
			var q1 = q[i];
			var s = [];
			var dim = Math.max(q0.length, q1.length);

			for (var j = 0; j < dim; j++) {
				var s0 = q0[j] || 0;
				var s1 = q1[j] || 0;

				s.push(s0 + (s1 - s0) * t);
			}

			r.push(s);
		}

		orders.push(r);
	}

	for (var _i = 0; _i < orders.length; _i++) {
		seg0.push(orders[_i][0]);
		seg1.push(orders[orders.length - 1 - _i][_i]);
	}

	return [seg0, seg1];
}

function until(points, threshold) {
	var deltaFunction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : euclideanDistance;

	var stack = [points];
	var segments = [];

	while (stack.length > 0) {
		var currentPoints = stack.pop();

		if (deltaFunction(currentPoints) > threshold) {
			var newPoints = split(currentPoints);

			// Add new segments backwards so they end up in correct order
			for (var i = newPoints.length - 1; i >= 0; i--) {
				stack.push(newPoints[i]);
			}
		} else {
			segments.push(currentPoints);
		}
	}

	return segments;
}

function euclideanDistance(points) {
	var startPoint = points[0];
	var endPoint = points[points.length - 1];
	var d2 = 0;

	for (var i = 0; i < startPoint.length; i++) {
		var d = endPoint[i] - startPoint[i];
		d2 += Math.pow(d, 2);
	}

	return Math.sqrt(d2);
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Warp = __webpack_require__(7);

var _Warp2 = _interopRequireDefault(_Warp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _Warp2.default;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _normalize = __webpack_require__(8);

var _utils = __webpack_require__(4);

var _parser = __webpack_require__(2);

var _parser2 = _interopRequireDefault(_parser);

var _encoder = __webpack_require__(3);

var _encoder2 = _interopRequireDefault(_encoder);

var _interpolate = __webpack_require__(5);

var _transform = __webpack_require__(15);

var _transform2 = _interopRequireDefault(_transform);

var _interpolate2 = __webpack_require__(16);

var _interpolate3 = _interopRequireDefault(_interpolate2);

var _extrapolate = __webpack_require__(17);

var _extrapolate2 = _interopRequireDefault(_extrapolate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Warp = function () {
	function Warp(element) {
		var curveType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'q';

		_classCallCheck(this, Warp);

		this.element = element;

		(0, _normalize.shapesToPaths)(element);
		(0, _normalize.preparePaths)(element, curveType);

		var pathElements = Array.from(element.querySelectorAll('path'));

		this.paths = pathElements.map(function (pathElement) {
			var pathString = (0, _utils.getProperty)(pathElement, 'd');
			var pathData = (0, _parser2.default)(pathString);

			return { pathElement: pathElement, pathData: pathData };
		});
	}

	_createClass(Warp, [{
		key: 'update',
		value: function update() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = this.paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _ref = _step.value;
					var pathElement = _ref.pathElement;
					var pathData = _ref.pathData;

					var pathString = (0, _encoder2.default)(pathData);
					(0, _utils.setProperty)(pathElement, 'd', pathString);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}, {
		key: 'transform',
		value: function transform(transformers) {
			transformers = Array.isArray(transformers) ? transformers : [transformers];

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = this.paths[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var path = _step2.value;

					path.pathData = (0, _transform2.default)(path.pathData, transformers);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			this.update();
		}
	}, {
		key: 'interpolate',
		value: function interpolate(threshold) {
			var didWork = false;

			function deltaFunction(points) {
				var linearPoints = [points[0].slice(0, 2), points[points.length - 1].slice(0, 2)];

				var delta = (0, _interpolate.euclideanDistance)(linearPoints);
				didWork = didWork || delta > threshold;

				return delta;
			}

			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = this.paths[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var path = _step3.value;

					path.pathData = (0, _interpolate3.default)(path.pathData, threshold, deltaFunction);
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			return didWork;
		}
	}, {
		key: 'extrapolate',
		value: function extrapolate(threshold) {
			var didWork = false;

			function deltaFunction(points) {
				var linearPoints = [points[0].slice(0, 2), points[points.length - 1].slice(0, 2)];

				var delta = (0, _interpolate.euclideanDistance)(linearPoints);
				didWork = didWork || delta <= threshold;

				return delta;
			}

			var _iteratorNormalCompletion4 = true;
			var _didIteratorError4 = false;
			var _iteratorError4 = undefined;

			try {
				for (var _iterator4 = this.paths[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
					var path = _step4.value;

					path.pathData = (0, _extrapolate2.default)(path.pathData, threshold, deltaFunction);
				}
			} catch (err) {
				_didIteratorError4 = true;
				_iteratorError4 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion4 && _iterator4.return) {
						_iterator4.return();
					}
				} finally {
					if (_didIteratorError4) {
						throw _iteratorError4;
					}
				}
			}

			return didWork;
		}
	}, {
		key: 'preInterpolate',
		value: function preInterpolate(transformer, threshold) {
			var didWork = false;

			function deltaFunction(points) {
				var linearPoints = [points[0].slice(0, 2), points[points.length - 1].slice(0, 2)];

				var delta = (0, _interpolate.euclideanDistance)(linearPoints);
				didWork = didWork || delta > threshold;

				return delta;
			}

			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = this.paths[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var path = _step5.value;

					var transformed = (0, _transform2.default)(path.pathData, function (points) {
						var newPoints = transformer(points.slice(0, 2));
						newPoints.push.apply(newPoints, _toConsumableArray(points));

						return newPoints;
					});

					var interpolated = (0, _interpolate3.default)(transformed, threshold, deltaFunction);

					path.pathData = (0, _transform2.default)(interpolated, function (points) {
						return points.slice(2);
					});
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}

			return didWork;
		}
	}, {
		key: 'preExtrapolate',
		value: function preExtrapolate(transformer, threshold) {
			var didWork = false;

			function deltaFunction(points) {
				var linearPoints = [points[0].slice(0, 2), points[points.length - 1].slice(0, 2)];

				var delta = (0, _interpolate.euclideanDistance)(linearPoints);
				didWork = didWork || delta <= threshold;

				return delta;
			}

			var _iteratorNormalCompletion6 = true;
			var _didIteratorError6 = false;
			var _iteratorError6 = undefined;

			try {
				for (var _iterator6 = this.paths[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
					var path = _step6.value;

					var transformed = (0, _transform2.default)(path.pathData, function (points) {
						var newPoints = transformer(points.slice(0, 2));
						newPoints.push.apply(newPoints, _toConsumableArray(points));

						return newPoints;
					});

					var extrapolated = (0, _extrapolate2.default)(transformed, threshold, deltaFunction);

					path.pathData = (0, _transform2.default)(extrapolated, function (points) {
						return points.slice(2);
					});
				}
			} catch (err) {
				_didIteratorError6 = true;
				_iteratorError6 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion6 && _iterator6.return) {
						_iterator6.return();
					}
				} finally {
					if (_didIteratorError6) {
						throw _iteratorError6;
					}
				}
			}

			return didWork;
		}
	}]);

	return Warp;
}();

exports.default = Warp;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.shapesToPaths = shapesToPaths;
exports.preparePaths = preparePaths;

var _parser = __webpack_require__(2);

var _parser2 = _interopRequireDefault(_parser);

var _encoder = __webpack_require__(3);

var _encoder2 = _interopRequireDefault(_encoder);

var _transform = __webpack_require__(1);

var _transform2 = _interopRequireDefault(_transform);

var _absolute = __webpack_require__(9);

var _absolute2 = _interopRequireDefault(_absolute);

var _shortToLong = __webpack_require__(10);

var _shortToLong2 = _interopRequireDefault(_shortToLong);

var _hvzToLine = __webpack_require__(11);

var _hvzToLine2 = _interopRequireDefault(_hvzToLine);

var _lineToCurve = __webpack_require__(12);

var _lineToCurve2 = _interopRequireDefault(_lineToCurve);

var _arcToCurve = __webpack_require__(13);

var _arcToCurve2 = _interopRequireDefault(_arcToCurve);

var _shape = __webpack_require__(14);

var pathShape = _interopRequireWildcard(_shape);

var _utils = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function shapesToPaths(element) {
	var shapeMap = {
		line: function line(shapeElement) {
			return pathShape.line((0, _utils.getProperty)(shapeElement, 'x1'), (0, _utils.getProperty)(shapeElement, 'y1'), (0, _utils.getProperty)(shapeElement, 'x2'), (0, _utils.getProperty)(shapeElement, 'y2'));
		},
		polyline: function polyline(shapeElement) {
			return pathShape.polyline.apply(pathShape, _toConsumableArray(shapeElement.points));
		},
		polygon: function polygon(shapeElement) {
			return pathShape.polygon.apply(pathShape, _toConsumableArray(shapeElement.points));
		},
		rect: function rect(shapeElement) {
			return pathShape.rectangle((0, _utils.getProperty)(shapeElement, 'x'), (0, _utils.getProperty)(shapeElement, 'y'), (0, _utils.getProperty)(shapeElement, 'width'), (0, _utils.getProperty)(shapeElement, 'height'), (0, _utils.getProperty)(shapeElement, 'rx'), (0, _utils.getProperty)(shapeElement, 'ry'));
		},
		ellipse: function ellipse(shapeElement) {
			return pathShape.ellipse((0, _utils.getProperty)(shapeElement, 'cx'), (0, _utils.getProperty)(shapeElement, 'cy'), (0, _utils.getProperty)(shapeElement, 'rx'), (0, _utils.getProperty)(shapeElement, 'ry'));
		},
		circle: function circle(shapeElement) {
			return pathShape.circle((0, _utils.getProperty)(shapeElement, 'cx'), (0, _utils.getProperty)(shapeElement, 'cy'), (0, _utils.getProperty)(shapeElement, 'r'));
		}
	};

	var shapeElements = element.querySelectorAll(Object.keys(shapeMap).join(','));

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = shapeElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var shapeElement = _step.value;

			var shapeName = shapeElement.tagName.toLowerCase();

			if (shapeName in shapeMap) {
				var path = shapeMap[shapeName](shapeElement);
				var pathString = (0, _encoder2.default)(path);
				var attributes = { d: pathString };

				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = Array.from(shapeElement.attributes)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var attribute = _step2.value;

						var name = attribute.nodeName;
						var value = attribute.nodeValue;

						// Avoid dimensional properties
						if (!/^(x|y|x1|y1|x2|y2|width|height|r|rx|ry|cx|cy|points|d)$/.test(name)) {
							attributes[name] = value;
						}
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				var pathElement = (0, _utils.createElement)('path', attributes);
				shapeElement.parentNode.replaceChild(pathElement, shapeElement);
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
}

function preparePaths(element) {
	var curveType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'q';

	var pathElements = Array.from(element.querySelectorAll('path'));

	var _iteratorNormalCompletion3 = true;
	var _didIteratorError3 = false;
	var _iteratorError3 = undefined;

	try {
		for (var _iterator3 = pathElements[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
			var pathElement = _step3.value;

			var pathString = (0, _utils.getProperty)(pathElement, 'd');
			var path = (0, _parser2.default)(pathString);

			path = (0, _transform2.default)(path, (0, _absolute2.default)());
			path = (0, _transform2.default)(path, (0, _shortToLong2.default)());
			path = (0, _transform2.default)(path, (0, _hvzToLine2.default)());
			path = (0, _transform2.default)(path, (0, _lineToCurve2.default)(curveType));
			path = (0, _transform2.default)(path, (0, _arcToCurve2.default)());

			pathString = (0, _encoder2.default)(path);

			(0, _utils.setProperty)(pathElement, 'd', pathString);
		}
	} catch (err) {
		_didIteratorError3 = true;
		_iteratorError3 = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion3 && _iterator3.return) {
				_iterator3.return();
			}
		} finally {
			if (_didIteratorError3) {
				throw _iteratorError3;
			}
		}
	}
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = absoluteGenerator;

var _utils = __webpack_require__(0);

function absoluteGenerator() {
	var xProps = ['x', 'x1', 'x2'];
	var yProps = ['y', 'y1', 'y2'];
	var drawingCmdExpr = /[lhvcsqta]/;

	var prevX = 0;
	var prevY = 0;
	var pathStartX = NaN;
	var pathStartY = NaN;

	return function absolute(segment) {
		if (isNaN(pathStartX) && (0, _utils.isDrawingSegment)(segment)) {
			pathStartX = prevX;
			pathStartY = prevY;
		}

		if (segment.type === 'z' && !isNaN(pathStartX)) {
			prevX = pathStartX;
			prevY = pathStartY;
			pathStartX = NaN;
			pathStartY = NaN;
		}

		if (segment.relative) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = xProps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var x = _step.value;

					if (x in segment) {
						segment[x] += prevX;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = yProps[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var y = _step2.value;

					if (y in segment) {
						segment[y] += prevY;
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			segment.relative = false;
		}

		prevX = 'x' in segment ? segment.x : prevX;
		prevY = 'y' in segment ? segment.y : prevY;

		if (segment.type === 'm') {
			pathStartX = prevX;
			pathStartY = prevY;
		}

		return segment;
	};
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = shortToLongGenerator;
function shortToLongGenerator() {
	var prevX = 0;
	var prevY = 0;
	var pathStartX = NaN;
	var pathStartY = NaN;
	var prevCurveC2X = NaN;
	var prevCurveC2Y = NaN;
	var prevQuadCX = NaN;
	var prevQuadCY = NaN;

	return function shortToLong(segment) {
		if (isNaN(pathStartX) && segment.type !== 'm') {
			throw new Error('Transform path error: path must start with "moveto"');
		}

		if (segment.type === 's') {
			prevCurveC2X = isNaN(prevCurveC2X) ? prevX : prevCurveC2X;
			prevCurveC2Y = isNaN(prevCurveC2Y) ? prevY : prevCurveC2Y;

			segment.type = 'c';
			segment.x1 = (segment.relative ? 1 : 2) * prevX - prevCurveC2X;
			segment.y1 = (segment.relative ? 1 : 2) * prevY - prevCurveC2Y;
		}

		if (segment.type === 'c') {
			prevCurveC2X = (segment.relative ? prevX : 0) + segment.x2;
			prevCurveC2Y = (segment.relative ? prevY : 0) + segment.y2;
		} else {
			prevCurveC2X = NaN;
			prevCurveC2Y = NaN;
		}

		if (segment.type === 't') {
			prevQuadCX = isNaN(prevQuadCX) ? prevX : prevQuadCX;
			prevQuadCY = isNaN(prevQuadCY) ? prevY : prevQuadCY;

			segment.type = 'q';
			segment.x1 = (segment.relative ? 1 : 2) * prevX - prevQuadCX;
			segment.y1 = (segment.relative ? 1 : 2) * prevY - prevQuadCY;
		}

		if (segment.type === 'q') {
			prevQuadCX = (segment.relative ? prevX : 0) + segment.x1;
			prevQuadCY = (segment.relative ? prevY : 0) + segment.y1;
		} else {
			prevQuadCX = NaN;
			prevQuadCY = NaN;
		}

		if (segment.type === 'z') {
			prevX = pathStartX;
			prevY = pathStartY;
		}

		prevX = 'x' in segment ? (segment.relative ? prevX : 0) + segment.x : prevX;
		prevY = 'y' in segment ? (segment.relative ? prevY : 0) + segment.y : prevY;

		if (segment.type === 'm') {
			pathStartX = prevX;
			pathStartY = prevY;
		}

		return segment;
	};
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = hvzToLineGenerator;
function hvzToLineGenerator() {
	var prevX = 0;
	var prevY = 0;
	var pathStartX = NaN;
	var pathStartY = NaN;

	return function hvzToLine(segment) {
		if (isNaN(pathStartX) && segment.type !== 'm') {
			throw new Error('Transform path error: path must start with "moveto"');
		}

		switch (segment.type) {
			case 'h':
				{
					segment.type = 'l';
					segment.y = segment.relative ? 0 : prevY;
				}
				break;
			case 'v':
				{
					segment.type = 'l';
					segment.x = segment.relative ? 0 : prevX;
				}
				break;
			case 'z':
				{
					segment.type = 'l';
					segment.x = pathStartX - (segment.relative ? prevX : 0);
					segment.y = pathStartY - (segment.relative ? prevY : 0);
				}
				break;
			case 'a':
				{
					if (segment.rx === 0 || segment.ry === 0) {
						segment.type = 'l';

						delete segment.rx;
						delete segment.ry;
						delete segment.xRotation;
						delete segment.largeArc;
						delete segment.sweep;
					}
				}
				break;
		}

		prevX = (segment.relative ? prevX : 0) + segment.x;
		prevY = (segment.relative ? prevY : 0) + segment.y;

		if (segment.type === 'm') {
			pathStartX = prevX;
			pathStartY = prevY;
		}

		return segment;
	};
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = lineToCurveGenerator;

var _utils = __webpack_require__(0);

function lineToCurveGenerator() {
	var curveType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'q';

	var prevX = 0;
	var prevY = 0;
	var pathStartX = NaN;
	var pathStartY = NaN;

	return function lineToCurve(segment) {
		if (isNaN(pathStartX) && (0, _utils.isDrawingSegment)(segment.type)) {
			pathStartX = prevX;
			pathStartY = prevY;
		}

		if (segment.type === 'z' && !isNaN(pathStartX)) {
			prevX = pathStartX;
			prevY = pathStartY;
			pathStartX = NaN;
			pathStartY = NaN;
		}

		if (segment.type === 'l') {
			var startX = segment.relative ? 0 : prevX;
			var startY = segment.relative ? 0 : prevY;

			segment.type = curveType;

			switch (curveType) {
				case 'q':
					{
						segment.x1 = (startX + segment.x) / 2;
						segment.y1 = (startY + segment.y) / 2;
					}
					break;
				case 'c':
					{
						var offsetX = (segment.x - startX) / 3;
						var offsetY = (segment.y - startY) / 3;

						segment.x1 = startX + offsetX;
						segment.y1 = startY + offsetY;
						segment.x2 = startX + 2 * offsetX;
						segment.y2 = startY + 2 * offsetY;
					}
					break;
				default:
					{
						throw new Error('Invalid curve type "' + curveType + '"');
					}
			}
		}

		prevX = 'x' in segment ? (segment.relative ? prevX : 0) + segment.x : prevX;
		prevY = 'y' in segment ? (segment.relative ? prevY : 0) + segment.y : prevY;

		if (segment.type === 'm') {
			pathStartX = prevX;
			pathStartY = prevY;
		}

		return segment;
	};
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = arcToCurveGenerator;

var _utils = __webpack_require__(0);

function arcToCurveGenerator() {
	var prevX = 0;
	var prevY = 0;
	var pathStartX = NaN;
	var pathStartY = NaN;

	return function arcToCurve(segment) {
		var segments = segment;

		if (isNaN(pathStartX) && (0, _utils.isDrawingSegment)(segment.type)) {
			pathStartX = prevX;
			pathStartY = prevY;
		}

		if (segment.type === 'z' && !isNaN(pathStartX)) {
			prevX = pathStartX;
			prevY = pathStartY;
			pathStartX = NaN;
			pathStartY = NaN;
		}

		if (segment.type === 'a') {
			var startX = segment.relative ? 0 : prevX;
			var startY = segment.relative ? 0 : prevY;
			var rx = segment.rx,
			    ry = segment.ry,
			    xRotation = segment.xRotation,
			    largeArc = segment.largeArc,
			    sweep = segment.sweep,
			    x = segment.x,
			    y = segment.y;

			var curveSegments = converter(startX, startY, rx, ry, xRotation, largeArc, sweep, x, y);

			var prevCurveX = 0;
			var prevCurveY = 0;

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = curveSegments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var curveSegment = _step.value;

					curveSegment.relative = segment.relative;

					if (segment.relative && curveSegment.type === 'c') {
						curveSegment.x -= prevCurveX;
						curveSegment.x1 -= prevCurveX;
						curveSegment.x2 -= prevCurveX;
						curveSegment.y -= prevCurveY;
						curveSegment.y1 -= prevCurveY;
						curveSegment.y2 -= prevCurveY;
					}

					prevCurveX = curveSegment.x;
					prevCurveY = curveSegment.y;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			segments = curveSegments;
		}

		prevX = 'x' in segment ? (segment.relative ? prevX : 0) + segment.x : prevX;
		prevY = 'y' in segment ? (segment.relative ? prevY : 0) + segment.y : prevY;

		if (segment.type === 'm') {
			pathStartX = prevX;
			pathStartY = prevY;
		}

		return segments;
	};
}

function converter(sx, sy, rx, ry, angle, large, sweep, x, y) {
	if (sx === x && sy === y) {
		return [];
	}

	if (!rx && !ry) {
		return [{ type: 'l', x: x, y: y }];
	}

	var sinPhi = Math.sin(angle * Math.PI / 180);
	var cosPhi = Math.cos(angle * Math.PI / 180);

	var xd = cosPhi * (sx - x) / 2 + sinPhi * (sy - y) / 2;
	var yd = -sinPhi * (sx - x) / 2 + cosPhi * (sy - y) / 2;

	var rx2 = rx * rx;
	var ry2 = ry * ry;

	var xd2 = xd * xd;
	var yd2 = yd * yd;

	var root = 0;
	var numerator = rx2 * ry2 - rx2 * yd2 - ry2 * xd2;

	if (numerator < 0) {
		var s = Math.sqrt(1 - numerator / (rx2 * ry2));

		rx *= s;
		ry *= s;
	} else {
		root = (large && sweep || !large && !sweep ? -1 : 1) * Math.sqrt(numerator / (rx2 * yd2 + ry2 * xd2));
	}

	var cxd = root * rx * yd / ry;
	var cyd = -root * ry * xd / rx;

	var cx = cosPhi * cxd - sinPhi * cyd + (sx + x) / 2;
	var cy = sinPhi * cxd + cosPhi * cyd + (sy + y) / 2;

	var theta1 = angleBetween(1, 0, (xd - cxd) / rx, (yd - cyd) / ry);
	var dtheta = angleBetween((xd - cxd) / rx, (yd - cyd) / ry, (-xd - cxd) / rx, (-yd - cyd) / ry);

	if (!sweep && dtheta > 0) {
		dtheta -= Math.PI * 2;
	} else if (sweep && dtheta < 0) {
		dtheta += Math.PI * 2;
	}

	var segments = [];
	var numSegs = Math.ceil(Math.abs(dtheta / (Math.PI / 2)));
	var delta = dtheta / numSegs;
	var t = 8 / 3 * Math.sin(delta / 4) * Math.sin(delta / 4) / Math.sin(delta / 2);

	for (var i = 0; i < numSegs; i++) {
		var cosTheta1 = Math.cos(theta1);
		var sinTheta1 = Math.sin(theta1);
		var theta2 = theta1 + delta;
		var cosTheta2 = Math.cos(theta2);
		var sinTheta2 = Math.sin(theta2);

		var epx = cosPhi * rx * cosTheta2 - sinPhi * ry * sinTheta2 + cx;
		var epy = sinPhi * rx * cosTheta2 + cosPhi * ry * sinTheta2 + cy;

		var dx = t * (-cosPhi * rx * sinTheta1 - sinPhi * ry * cosTheta1);
		var dy = t * (-sinPhi * rx * sinTheta1 + cosPhi * ry * cosTheta1);

		var dxe = t * (cosPhi * rx * sinTheta2 + sinPhi * ry * cosTheta2);
		var dye = t * (sinPhi * rx * sinTheta2 - cosPhi * ry * cosTheta2);

		segments.push({
			type: 'c',
			x: epx,
			y: epy,
			x1: sx + dx,
			y1: sy + dy,
			x2: epx + dxe,
			y2: epy + dye
		});

		theta1 = theta2;
		sx = epx;
		sy = epy;
	}

	return segments;
}

function angleBetween(ux, uy, vx, vy) {
	var ta = Math.atan2(uy, ux);
	var tb = Math.atan2(vy, vx);

	if (tb >= ta) {
		return tb - ta;
	}

	return Math.PI * 2 - (ta - tb);
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.line = line;
exports.polyline = polyline;
exports.polygon = polygon;
exports.rectangle = rectangle;
exports.ellipse = ellipse;
exports.circle = circle;
function line(x1, y1, x2, y2) {
	var relative = false;

	return [{ type: 'm', relative: relative, x: x1, y: y1 }, { type: 'l', relative: relative, x: x2, y: y2 }];
}

function polyline() {
	for (var _len = arguments.length, points = Array(_len), _key = 0; _key < _len; _key++) {
		points[_key] = arguments[_key];
	}

	return points.map(function (p, i) {
		return {
			type: i === 0 ? 'm' : 'l',
			relative: false,
			x: p.x || p[0],
			y: p.y || p[1]
		};
	});
}

function polygon() {
	var path = polyline.apply(undefined, arguments);
	path.append({ type: 'z', relative: false });

	return path;
}

function rectangle(x, y, width, height) {
	var rx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	var ry = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

	var relative = false;
	var path = void 0;

	if (rx > 0 || ry > 0) {
		// If one of the properties is not defined or zero, then it's just given the value of the other
		rx = rx || ry;
		ry = ry || rx;

		var xRotation = 0;
		var largeArc = false;
		var sweep = true;

		path = [{ type: 'm', relative: relative, x: x + rx, y: y }, { type: 'h', relative: relative, x: x + width - rx }, { type: 'a', relative: relative, rx: rx, ry: ry, xRotation: xRotation, largeArc: largeArc, sweep: sweep, x: x + width, y: y + ry }, { type: 'v', relative: relative, y: y + height - ry }, { type: 'a', relative: relative, rx: rx, ry: ry, xRotation: xRotation, largeArc: largeArc, sweep: sweep, x: x + width - rx, y: y + height }, { type: 'h', relative: relative, x: x + rx }, { type: 'a', relative: relative, rx: rx, ry: ry, xRotation: xRotation, largeArc: largeArc, sweep: sweep, x: x, y: y + height - ry }, { type: 'v', relative: relative, y: y + ry }, { type: 'a', relative: relative, rx: rx, ry: ry, xRotation: xRotation, largeArc: largeArc, sweep: sweep, x: x + rx, y: y }];
	} else {
		path = [{ type: 'm', relative: relative, x: x, y: y }, { type: 'h', relative: relative, x: x + width }, { type: 'v', relative: relative, y: y + height }, { type: 'h', relative: relative, x: x }, { type: 'v', relative: relative, y: y }];
	}

	return path;
}

function ellipse(cx, cy, rx, ry) {
	var relative = false;
	var xRotation = 0;
	var largeArc = false;
	var sweep = true;

	return [{ type: 'm', relative: relative, x: cx, y: cy - ry }, { type: 'a', relative: relative, rx: rx, ry: ry, xRotation: xRotation, largeArc: largeArc, sweep: sweep, x: cx, y: cy + ry }, { type: 'a', relative: relative, rx: rx, ry: ry, xRotation: xRotation, largeArc: largeArc, sweep: sweep, x: cx, y: cy - ry }];
}

function circle(cx, cy, r) {
	return ellipse(cx, cy, r, r);
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = transform;

var _transform = __webpack_require__(1);

var _transform2 = _interopRequireDefault(_transform);

var _utils = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function transform(path, transformers) {
	return (0, _transform2.default)(path, function (segment) {
		for (var i = 0; i < _utils.pointGroups.length; i++) {
			var _pointGroups$i = _slicedToArray(_utils.pointGroups[i], 2),
			    x = _pointGroups$i[0],
			    y = _pointGroups$i[1];

			if (x in segment && y in segment) {
				var extendedPoints = (segment.extended ? segment.extended[i] : null) || [];
				var oldPoints = [segment[x], segment[y]].concat(_toConsumableArray(extendedPoints));
				var newPoints = transformers.reduce(function (points, transformer) {
					return transformer(points);
				}, oldPoints);

				if (newPoints.length < 2) {
					throw new Error('Transformer must return at least 2 points');
				}

				segment[x] = newPoints[0];
				segment[y] = newPoints[1];

				if (newPoints.length > 2) {
					segment.extended = segment.extended || {};
					segment.extended[i] = newPoints.slice(2);
				}
			}
		}

		return segment;
	});
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = interpolate;

var _transform = __webpack_require__(1);

var _transform2 = _interopRequireDefault(_transform);

var _interpolate = __webpack_require__(5);

var _utils = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var interpolationTypesExpr = /[lqc]/;

function interpolate(path, threshold, deltaFunction) {
	var prevPoints = [];

	return (0, _transform2.default)(path, function (segment) {
		var segments = segment;

		if (interpolationTypesExpr.test(segment.type)) {
			var points = [prevPoints];

			for (var j = 0; j < _utils.pointGroups.length; j++) {
				var _pointGroups$j = _slicedToArray(_utils.pointGroups[j], 2),
				    x = _pointGroups$j[0],
				    y = _pointGroups$j[1];

				if (x in segment && y in segment) {
					var extendedPoints = (segment.extended ? segment.extended[j] : null) || [];
					var pointList = [segment[x], segment[y]].concat(_toConsumableArray(extendedPoints));

					points.push(pointList);
				}
			}

			var rawSegments = (0, _interpolate.until)(points, threshold, deltaFunction);

			if (rawSegments.length > 1) {
				segments = rawSegments.map(function (rawSegment) {
					return (0, _utils.createLineSegment)(rawSegment);
				});
			}
		}

		if ('x' in segment && 'y' in segment) {
			var _extendedPoints = (segment.extended ? segment.extended[2] : null) || [];
			var _pointList = [segment.x, segment.y].concat(_toConsumableArray(_extendedPoints));

			prevPoints = _pointList;
		}

		return segments;
	});
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = extrapolate;

var _transform = __webpack_require__(1);

var _transform2 = _interopRequireDefault(_transform);

var _utils = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extrapolationTypesExpr = /[lqc]/;

function extrapolate(path, threshold, deltaFunction) {
	return (0, _transform2.default)(path, function (segment, i, oldPath, newPath) {
		if (i > 1) {
			var prevSegment = newPath[newPath.length - 1];
			var prevSegment2 = newPath[newPath.length - 2];

			if (extrapolationTypesExpr.test(segment.type) && prevSegment.type === segment.type) {
				var points = [[prevSegment2.x, prevSegment2.y], [segment.x, segment.y]];

				if (deltaFunction(points) <= threshold) {
					var newSegment = (0, _utils.joinSegments)(prevSegment, segment);

					if (newSegment) {
						newPath[newPath.length - 1] = newSegment;

						return false;
					}
				}
			}
		}

		return segment;
	});
}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// warp.js